// Takes in a cookie name and returns its value
// This returns an empty string if cookie name is not found
export default function getCookie(cname) {
  const cookieName = `${cname}=`;

  // This fetches all cookies
  const decodedCookie = decodeURIComponent(document.cookie);

  // Convert cookie data to be an array
  const decodedCookieSplit = decodedCookie.split(';');

  for (let i = 0; i < decodedCookieSplit.length; i++) {
    let c = decodedCookieSplit[i];

    // Removes space character at the beginning of string
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }

    // If cookie name is found, return its value
    if (c.indexOf(cookieName) === 0) {
      return c.substring(cookieName.length, c.length);
    }
  }

  return '';
}
